export var wishlist = [
    {
        id: "3",
        urlPath: '../la-mer',
        title: 'La crème régénératrice',
        urlImg: '../assets/wish1.png',
        price: '212,00€',
        cssClass: "",
        __typename: "MenuItem"
    },
    {
        id: "4",
        title: 'Le masque revigorant',
        urlPath: '../gucci',
        price: '212,00€',
        urlImg: '../assets/wish3.png',
        cssClass: "",
        __typename: "MenuItem"
    },
    {
        id: "4",
        title: 'La crème régénératrice',
        urlPath: '../dior',
        price: '123,00€',
        urlImg: '../assets/wish1.png',
        cssClass: "",
        __typename: "MenuItem"
    },
    {
        id: "4",
        title: 'Le masque revigorant',
        urlPath: '../dior',
        urlImg: '../assets/wish1.png',
        price: '123,00€',
        cssClass: "",
        __typename: "MenuItem"
    },
    {
        id: "4",
        title: 'La crème régénératrice',
        urlPath: '../gucci',
        urlImg: '../assets/wish3.png',
        price: '280,00€',
        cssClass: "",
        __typename: "MenuItem"
    },
];
//# sourceMappingURL=dataWishlist.js.map